/**
 * The chop (owner, 2026-09-29: "*CHOP* of the Cleaver UI nice Job"): after a clean "Log it", the landing page's cleaver
 * (apps/landing chop.js: lift, strike, a small squash, diced pieces) chops once in the toast, with a tiny "*chop*"
 * and a few water-colored crumbs, about 800 ms, then rests. CSS only (transform and opacity, DESIGN §4 / MOTION.md hard
 * limits); Reduce Motion shows the still cleaver and the crumbs at rest. No sound. Never after a safety failure: the
 * caller decides with core savedMoment (humor never goes near a problem, AD-CAMPAIGN.md).
 */
import { type CSSProperties } from "react";
import { prefersReducedMotion } from "../lib/motion.ts";
import { Cleaver } from "./Brand.tsx";

const CRUMBS = [
  { x: 40, c: "#5CC8E8", dx: -26, r: -40 }, { x: 58, c: "#F2C14E", dx: -12, r: 30 }, { x: 76, c: "#FFFFFF", dx: -2, r: -15 },
  { x: 94, c: "#0A7090", dx: 10, r: 50 }, { x: 112, c: "#5CC8E8", dx: 22, r: -30 }, { x: 128, c: "#F2C14E", dx: 34, r: 20 },
];

export function ChopCleaver({ still }: { /** Force the still picture (tests; otherwise Reduce Motion decides). */ still?: boolean }) {
  const calm = still ?? prefersReducedMotion();
  return (
    <span className={`chop ${calm ? "chop-still" : "chop-go"}`} aria-hidden="true" data-testid="chop">
      <svg viewBox="0 0 230 140" width="92" height="56">
        <rect className="chop-board" x="6" y="124" width="218" height="9" rx="4.5" />
        <g className="chop-blade"><g transform="translate(10 18)"><Cleaver ink="#FBFAF6" /></g></g>
        <g className="chop-crumbs" stroke="#17232E" strokeWidth="1.2">
          {CRUMBS.map((k, i) => <rect key={i} className="chop-crumb" x={k.x} y="116" width="12" height="8" rx="2.5" fill={k.c} style={{ "--dx": `${k.dx}px`, "--r": `${k.r}deg`, animationDelay: `${440 + i * 18}ms` } as CSSProperties} />)}
        </g>
      </svg>
      <span className="chop-word">*chop*</span>
    </span>
  );
}
